import { useAtomValue } from "jotai";

import { registerEmailCookieAtom, useRegisterEmailExpirationEffect } from "~/lib/account";

import { HomeAccountActivation } from ".";

export const useHomeAccountActivation = () => {
  const { registerEmail } = useAtomValue(registerEmailCookieAtom);

  useRegisterEmailExpirationEffect();

  if (!registerEmail) return;
  return <HomeAccountActivation email={registerEmail} />;
};
